import { UIFlightData, UIClientFetchError } from "@flights/types";
import { ActionsUnion, createAction } from "@bookingcom/flights-core";

export enum ActionTypes {
  fetch = "flightDetails/fetch",
  fetchReset = "flightDetails/fetchReset",
  fetchSuccess = "flightDetails/fetchSuccess",
  fetchError = "flightDetails/fetchError"
}

export const actions = {
  fetch: createAction((options?: { clearFlight?: boolean }) => ({
    type: ActionTypes.fetch,
    payload: { clearFlight: options?.clearFlight ?? true }
  })),

  fetchReset: createAction(() => ({
    type: ActionTypes.fetchReset,
    payload: {}
  })),

  fetchSuccess: createAction((flight: UIFlightData) => ({
    type: ActionTypes.fetchSuccess,
    payload: { flight }
  })),

  fetchError: createAction((error: UIClientFetchError) => ({
    type: ActionTypes.fetchError,
    payload: { error }
  }))
};

export type Actions = ActionsUnion<typeof actions>;
